import { defineMessages } from 'react-intl'

export const purchaseSubscriptionMessages = defineMessages({
  networkAISubscriptionLabel: {
    id: 'purchaseSubscription.networkAISubscriptionLabel',
    description: 'Network AI Subscription label',
    defaultMessage: 'Smart Network Subscription',
  },
  accessPointsLabel: {
    id: 'purchaseSubscription.accessPointsLabel',
    description: 'Access Points label',
    defaultMessage: 'Access Points',
  },
  switchesLabel: {
    id: 'purchaseSubscription.switchesLabel',
    description: 'Switches label',
    defaultMessage: 'Switches',
  },
  wanEdgesLabel: {
    id: 'purchaseSubscription.wanEdgesLabel',
    description: 'Wan item label',
    defaultMessage: 'WAN Edges',
  },
  comingSoonLabel: {
    id: 'purchaseSubscription.comingSoonLabel',
    description: 'Coming soon label',
    defaultMessage: 'Coming Soon',
  },
  purchaseSubscriptionTitle: {
    id: 'purchaseSubscription.purchaseSubscriptionTitle',
    description: 'Purchase subscription title',
    defaultMessage: 'Purchase Subscription',
  },
  addPaymentMethodTitle: {
    id: 'purchaseSubscription.addPaymentMethodTitle',
    description: 'Add Payment Method page title',
    defaultMessage: 'Add Payment Method',
  },
  checkoutTitle: {
    id: 'purchaseSubscription.checkoutTitle',
    description: 'Checkout page title',
    defaultMessage: 'Checkout',
  },
  purchaseSubscriptionTotalToPay: {
    id: 'purchaseSubscription.purchaseSubscriptionTotalToPay',
    description: 'Total To Pay label',
    defaultMessage: 'Annual Total',
  },
  moreDetailsTitle: {
    id: 'purchaseSubscription.moreDetailsTitle',
    description: 'More Details button title',
    defaultMessage: 'More Details',
  },
  purchaseTitle: {
    id: 'purchaseSubscription.purchaseTitle',
    description: 'Purchase button title',
    defaultMessage: 'Purchase',
  },
  purchaseAndSubscribeTitle: {
    id: 'purchaseSubscription.purchaseAndSubscribeTitle',
    description: 'Purchase button title',
    defaultMessage: 'Pay Now & Subscribe',
  },
  claimDevices: {
    id: 'purchaseSubscription.claimDevices',
    description: 'Button title to claim devices',
    defaultMessage: 'Claim Devices',
  },
  purchaseTimeframe: {
    id: 'purchaseSubscription.purchaseTimeframe',
    description: 'Title to purchase time frame',
    defaultMessage: 'annually',
  },
  claimMessage: {
    id: 'purchaseSubscription.claimMessage',
    description: 'Message for remaining unclaimes subs.',
    defaultMessage: 'unclaimed Smart Network subscriptions',
  },
  manage: {
    id: 'purchaseSubscription.manage',
    description: 'Message for remaining unclaimes subs.',
    defaultMessage: 'Manage',
  },
  cancelRenewal: {
    id: 'purchaseSubscription.cancelRenewal',
    description: 'Message for remaining unclaimes subs.',
    defaultMessage: 'Cancel Renewal',
  },
})
